import { Auth } from "aws-amplify";
import jwt from "jwt-decode";
import { UserProps } from "../../domain/models/user";
import { settings } from "../../main/configs/settings";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import LocalStorage from "../localStorage";

type DataJwt = {
  email?: string;
  sub?: string;
  "cognito:username"?: string;
};
class Authentication {
  private static currentUser: any;

  static login(username: string, password: string): Promise<void> {
    return new Promise((resolve, reject) => {
      Auth.signIn(username, password)
        .then(async (res) => {
          this.currentUser = res;

          await LocalStorage.set("connected", true);
          await LocalStorage.set("username", username);
          await LocalStorage.set("usernameCognito", res.username);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static loginLinkedin(): Promise<any> {
    
    return new Promise((resolve, reject) => {
      Auth.federatedSignIn({ customProvider: settings.CUSTOM_PROVIDER ?? "" })
        .then(async (res) => {
          await LocalStorage.set("connected", true);
          await this.isAuthOnlyLinkedin();
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static async setIsheadeOffice(isHeadOffice: boolean): Promise<void> {
    await LocalStorage.set("isHeadOffice", isHeadOffice);
  }

  static async getUserInfo(): Promise<UserProps | null> {
    const userData = await LocalStorage.get("user");
    return userData;
  }

  static isAuth(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Auth.currentSession()
        .then(async (res) => {
          if (res.isValid()) {
            const dataJwt: DataJwt = await jwt(res.getIdToken().getJwtToken());
            Auth.configure({ storage: window.localStorage });
            await LocalStorage.set("connected", true);
            await LocalStorage.set("username", dataJwt?.email);
            await LocalStorage.set(
              "usernameCognito",
              dataJwt?.["cognito:username"]
            );
            LocalStorageUtils.setItem(
              JSON.stringify(dataJwt?.["cognito:username"]),
              "cognitoUser"
            );
            resolve(true);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static isAuthOnlyLinkedin(): Promise<any> {
    return new Promise((resolve, reject) => {
      Auth.currentSession()
        .then(async (res) => {
          if (res.isValid()) {
            const dataJwt: any = await jwt(res.getIdToken().getJwtToken());
            Auth.configure({ storage: window.localStorage });
            await LocalStorage.set("connected", true);
            await LocalStorage.set("username", dataJwt?.email);
            LocalStorageUtils.setItem(
              JSON.stringify(dataJwt?.["cognito:username"]),
              "cognitoUser"
            );
            resolve(dataJwt);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static logout(): Promise<void> {
    return new Promise((resolve, reject) => {
      Auth.signOut()
        .then((res) => {
          if (window.location.pathname.includes("/admin")) {
            window.location.href = "/admin";
          } else {
            window.location.href = "/";
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(async () => {
          await LocalStorage.remove("connected");
          await LocalStorage.remove("user");
          await LocalStorage.remove("username");
        });
    });
  }

  static forgotPassword(email: string): Promise<void> {
    return new Promise((resolve, reject) => {
      Auth.forgotPassword(email)
        .then(async (res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static changePassword(
    token: string,
    oldPassword: string,
    password: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      Auth.changePassword(token, oldPassword, password)
        .then(async (resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static recoveryPassword(
    email: string,
    code: string,
    password: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      Auth.forgotPasswordSubmit(email, code, password)
        .then(async (res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static newPasswordRequired(password: string): Promise<void> {
    return new Promise((resolve, reject) => {
      Auth.completeNewPassword(this.currentUser, password)
        .then(async (res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      Auth.currentSession()
        .then(async (res) => {
          if (res.isValid()) {
            resolve(res.getIdToken().getJwtToken());
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default Authentication;
